import { Component } from '@angular/core';
// import { Store, Select } from '@ngxs/store';
import { forkJoin, Subscription } from 'rxjs';
// import { OrderState } from '../../../shared/state/order.state';
// import { GetOrders } from '../../../shared/action/order.action';
// import { OrderModel } from '../../../shared/interface/order.interface';
import { Params } from '../../../shared/interface/core.interface';
import { OrderService } from '@/app/shared/services/order.service';
import { Order, OrderItem, OrderModel, OrderStatus } from '@/app/shared/interface/order.interface';
import { CatetoryQueryString, PageQueryString, SearchUserQueryString } from '@/app/shared/filter';
import { QueryStringService } from '@/app/shared/services/querystring.service';
import { ActivatedRoute, Router } from '@angular/router';
import { PaginationModel, RetriveUserModel } from '@/app/shared/interface/product.interface';
import { DomSanitizer } from '@angular/platform-browser';
import { ToastrService } from 'ngx-toastr';
import { BaseResponseDataModel } from '@/app/shared/interface/base-response.interface';
import { useSafeTimeout } from '@/app/shared/ssr-util';

@Component({
  selector: 'app-orders',
  templateUrl: './orders.component.html',
  styleUrls: ['./orders.component.scss']
})
export class OrdersComponent {

  public orders: Order[] = [];
  public totalWithFilters: number = 0;
  public totalNoFilters: number = 0;

  public skeletonLoader: boolean = false;
  public skeletonItems = Array.from({ length: 40 }, (_, index) => index);

  public inputText: string;
  private changeQueryStringSubcription?: Subscription;
  public searchUserQuery: SearchUserQueryString = new SearchUserQueryString();
  public categoryQuery: CatetoryQueryString = new CatetoryQueryString();
  public searchOptions = [
    { name: 'Mã đơn hàng', key: 'orderId' },
    { name: 'Mã hóa đơn', key: 'invoiceNumber' },
    { name: 'Mã sản phẩm', key: 'productSku' },
    { name: 'Tên sản phẩm', key: 'productName' },
    { name: 'Mã LOT sản phẩm', key: 'lot' }
  ];
  public selectedSearchOption = this.searchOptions[0];
  public isSearchMenuOpen = false;
  public fromDate = '';
  public toDate = '';

  public filters = [
    {
      name: "Tất cả",
      active: true,
      value: 0,
      type: -1
    },
    {
      name: "Đang xác nhận",
      active: false,
      value: 0,
      type: 0
    },
    {
      name: "Đã thanh toán",
      active: false,
      value: 0,
      type: 5
    },
    {
      name: "Đã tách đơn",
      active: false,
      value: 0,
      type: 50
    },
    {
      name: "Đang xử lý",
      active: false,
      value: 0,
      type: 1
    },
    {
      name: "Đang vận chuyển",
      active: false,
      value: 0,
      type: 2
    },
    {
      name: "Đã hoàn thành",
      active: false,
      value: 0,
      type: 3
    },
    {
      name: "Đã hủy",
      active: false,
      value: 0,
      type: 40
    }
  ];

  bodyProduct: any = {
    limit: 10,
    offset: 0,
  };
  private searchCriteria: any = {};

  private safeTimeout = useSafeTimeout();

  constructor(
    private orderService: OrderService,
    private queryStringService: QueryStringService,
    private route: ActivatedRoute,
    private toastService: ToastrService,
    private router: Router,
    private _sanitizer: DomSanitizer
  ) {
    // this.store.dispatch(new GetOrders(this.filter));
  }

  rows =
  {
    id: 1,
    invoices: [
      { name: 'Hóa đơn 1', url: 'https://example.com/invoice-1' },
      { name: 'Hóa đơn 2', url: 'https://example.com/invoice-2' },
      { name: 'Hóa đơn 3', url: 'https://example.com/invoice-3' }
    ]
  }


  ngOnInit() {
    this.categoryQuery = this.queryStringService.getQueryString(new CatetoryQueryString());
    this.changeQueryStringSubcription = this.queryStringService.eventChangeQueryString.subscribe(() => {
      this.searchUserQuery = this.queryStringService.getQueryString(new SearchUserQueryString());
    });

    this.route.queryParams.subscribe(params => {
      if (params["s"]) {
        this.inputText = params["s"];
        this.search(this.inputText);
      }
      else {
        this.getUserOrders();
      }
      if (params["category"]) {
        this.setActive(params["category"]);
      }
    });

  }

  getUserOrders(resetPage = false) {
    let body = this.queryStringService.buildFetchingModel(this.bodyProduct.limit);
    if (body.searchTerm) {
      body.searchTerm = body.searchTerm.trim().toLowerCase();
    }
    if (this.bodyProduct.orderStatuses) {
      body.orderStatuses = this.bodyProduct.orderStatuses;
    }
    Object.assign(body, this.searchCriteria);
    if (resetPage) {
      body.offset = 0;
    }
    this.skeletonLoader = true;
    this.orderService.getOrders(JSON.stringify(body)).subscribe({
      next: (res: OrderModel) => {
        if (res.orderHistory && res.orderHistory?.length > 0) {
          this.orders = res.orderHistory;
          this.totalWithFilters = res.total;
          this.safeTimeout(() => {
            this.queryStringService.changePagination(pagination);
          }, 10);
          for (let order of this.orders) {
            if (order.childOrderIds?.length) {
              const observableChildOrders = [];
              for (let childOrderId of order.childOrderIds) {
                const body = {
                  orderId: childOrderId
                }
                const childOrderObservable = this.orderService.getOrders(JSON.stringify(body));
                observableChildOrders.push(childOrderObservable);
              }
              forkJoin(observableChildOrders).subscribe({
                next: (res: OrderModel[]) => {
                  order.childOrders = res.map(r => r.orderHistory).flat();
                },
                error: (error: any) => {
                  console.log(error);
                }
              });
            }
          }
        }
        else {
          this.orders = [];
        }

        this.totalNoFilters = res.totalCountNoFilters;
        let pagination: PaginationModel = {
          limit: body.limit,
          offset: body.offset,
          searchTerm: body.searchTerm ?? "",
          totalItems: res.total,
          sortBy: body.sortBy ?? "",
          category: body.category ?? "",
        };

        for (let filter of this.filters) {
          const orderStatus = filter.type;
          if (orderStatus !== -1) {
            filter.value = res.statusCount.find(x => x.status == orderStatus)?.count ?? 0;
          }
          else {
            filter.value = this.totalNoFilters;
          }
        }
      },
       error: (error: any) => {
        console.log(error);
      },
      complete: () => {
        this.skeletonLoader = false;
      }
    })
  }

  search(value: string) {
    const searchValue = (value ?? '').trim();
    const criteria: any = {};
    if (searchValue) {
      criteria[this.selectedSearchOption.key] = searchValue;
    }
    const isLot = this.selectedSearchOption.key === 'lot';
    if (this.fromDate) {
      criteria[isLot ? 'fromExpiredDateLot' : 'fromDate'] = this.toIso8601(this.fromDate, false);
    }
    if (this.toDate) {
      criteria[isLot ? 'toExpiredDateLot' : 'toDate'] = this.toIso8601(this.toDate, true);
    }
    if (Object.keys(criteria).length) {
      criteria.maxNumberOfResult = 20;
    }
    this.searchCriteria = criteria;
    this.getUserOrders(true);
  }

  private toIso8601(date: string, endOfDay: boolean): string {
    return new Date(`${date}T${endOfDay ? '23:59:59.999' : '00:00:00'}`).toISOString();
  }

  selectSearchOption(option: typeof this.searchOptions[number]) {
    this.selectedSearchOption = option;
    if (option.key !== 'lot') {
      this.fromDate = '';
      this.toDate = '';
    }
    this.isSearchMenuOpen = false;
  }

  setActive(categories: string) {
    const categoryNames = categories.split(",");
    for (let filter of this.filters) {
      if (categoryNames.includes(filter.name)) {
        filter.active = true;
      }
    }
  }

  filter(e: any) {
    e.active = !e.active;
    for (let c of this.filters) {
      if (c.type != e.type) {
        c.active = false;
      }
    }
    if (e.type != -1) {
      this.bodyProduct.orderStatuses = [e.type];
    }
    else {
      this.bodyProduct.orderStatuses = [];
    }
    this.queryStringService.changeQueryString(new PageQueryString(1));
    this.getUserOrders();
  }

  changeQueryString() {
    let s = '';
    for (const c of this.filters) {
      if (c.active && c.type != -1) {
        s += `${c.name},`;
      }
    }
    this.categoryQuery.value = s.substring(0, s.length - 1);
    this.queryStringService.changeQueryString(this.categoryQuery);
  }

  ngOnDestroy() {
    this.changeQueryStringSubcription?.unsubscribe();
  }
}
